// Formata o telefone da instância para leitura humana. Veio da barra lateral
// antiga, quando a navegação subiu para o topo.
export default function formatPhoneBR(raw) {
  if (!raw) return ''
  const digits = String(raw).replace(/\D/g, '')

  // BR celular: 55 + DDD (2) + 9 + 8 dígitos
  if (digits.length === 13 && digits.startsWith('55')) {
    return `+55 (${digits.slice(2, 4)}) ${digits.slice(4, 5)} ${digits.slice(5, 9)}-${digits.slice(9)}`
  }
  if (digits.length === 12 && digits.startsWith('55')) {
    return `+55 (${digits.slice(2, 4)}) ${digits.slice(4, 8)}-${digits.slice(8)}`
  }
  if (digits.length === 11) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 3)} ${digits.slice(3, 7)}-${digits.slice(7)}`
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`
  }

  return raw
}
